import Component from '../core/Component'
import EventBus from '../core/EventBus'
import enquire from 'enquire.js'
import { queries } from '../core/config'

const ACTIVE = 'is-active'

export default class MenuToggler extends Component {

    static States = {
        ACTIVE
    }

    constructor(element) {
        super(element)

        this.enquireHandler = {
            match: ::this.reset
        }

        if (this.element.dataset.menu) {
            this.MENU = '.' + this.element.dataset.menu;
        }
    }

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
        enquire.register(queries.largeUp, this.enquireHandler)
    }

    destroy() {
        enquire.unregister(queries.largeUp, this.enquireHandler)
    }

    reset() {
        this.element.classList.remove(ACTIVE)
    }

    handleClick(event) {
        event.preventDefault()
        this.element.classList.toggle(ACTIVE)
        document.querySelector(this.MENU).classList.toggle('open')
    }

}
